import { Injectable } from '@angular/core';


export class CacheItem {
  code: any;
  object: any;
  expiryInSeconds: string | null = null
}

export enum CacheGroup{
  Api = "API",
  MedicalProcedures = 'MP'
}


@Injectable({
  providedIn: 'root'
})
export class CacheStorage {
  store: { [bucket: string]: CacheItem[]; } = {};
  applicationCacheStoreName: string = 'application-cache';

  add(group: string, key: string | number, value: any, expiry: string | null = null): void {
    if (!this.store[group]) {
      this.store[group] = [];
    }
    if (this.get(group, key) != null) {
      this.remove(group, key);
    }
    var bucket = this.store[group];
    bucket.push({ code: key, object: value, expiryInSeconds: expiry });
  }

  remove(group: string, key: string | number): void {
    var bucket = this.store[group];
    if (!bucket) {
      return;
    }

    var cacheItem = this.get(group, key);
    if (cacheItem == null) {
      return;
    }
    var index = bucket.indexOf(cacheItem);
    bucket.splice(index, 1);
  }

  removeAll(group: string): void {
    this.store[group] = [];
    localStorage.removeItem(this.applicationCacheStoreName);
  }

  get(group: string, key: string | number): CacheItem | null {
    var bucket = this.store[group];
    if (!bucket) {
      return bucket;
    }
    var cacheItems = bucket.filter(x => x.code == key);
    if (cacheItems.length > 0) {
      return this.checkForExpiryOnItem(cacheItems[0], group);
    }
    return null;
  }

  getAll(group: string): CacheItem[] {
    var bucket = this.store[group];
    if (!bucket) {
      return bucket;
    }
    return this.checkForexpiryOnGroup(bucket, group);
  }

  private checkForExpiryOnItem(item: CacheItem, group: string){
    if(item.expiryInSeconds == null || item.expiryInSeconds.length == 0){
      return item;
    }

    var nowInSeconds = Date.now();
    var expiryInSeconds = parseInt(item.expiryInSeconds);
    if (expiryInSeconds != null && expiryInSeconds >= nowInSeconds){
      return item;
    }else{      
      var bucket = this.store[group];
      
      var index = bucket.indexOf(item);
      bucket.splice(index, 1);

      return null;
    }
  }

  private checkForexpiryOnGroup(bucket: CacheItem[], group: string){
    bucket = bucket.filter(i => this.checkForExpiryOnItem(i, group) != null);

    this.store[group] = bucket;

    return bucket;
  }
}
